var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    [
      _c("AboutProjectBlock"),
      _c("AboutChildrenBlock", {
        attrs: { customBackground: "about-children__wrapper--first-block" }
      }),
      _c("AboutCategoryBlock"),
      _c("AboutPrizeBlock"),
      _c("AboutWorldContest", {
        attrs: { customBackground: "about-children__wrapper--second-block" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a606064", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a606064","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/about.vue
// module id = lZJo
// module chunks = 2